<div class="flex items-center justify-between w-full">
  <div class="active:scale-95 transition-transform">
    <app-dynamic
      componentName="IconButton"
      [props]="{
        config: {
          icon: 'caret-left-thin',
          size: 'md',
          border: false,
          ariaLabel: config().previousAriaLabel,
        },
      }"
      (action)="onPrevious()"
    />
  </div>

  <div
    class="flex items-center gap-2 px-4 py-1 rounded-full bg-(--dayswitcher-background) transition-all duration-200 ease-out cursor-pointer active:scale-95"
    (click)="onDateClick()"
  >
    <app-dynamic
      componentName="DynamicText"
      [props]="{
        config: {
          text: formattedDate(),
          size: 'base',
          fontWeight: 'bold',
          color: 'var(--dayswitcher-color)',
        },
      }"
    />
  </div>

  <app-dynamic
    componentName="IconButton"
    [props]="{
      config: {
        icon: 'caret-right-thin',
        size: 'md',
        border: false,
        ariaLabel: config().nextAriaLabel,
      },
    }"
    (action)="onNext()"
  />
</div>
